import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainContent" }
const _hoisted_2 = { class: "auxbanner" }

import { reactive } from 'vue';
import { AuxBanner } from '@ambita/design-system';

// Info for now. Please remove with update.

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const banner = reactive({
  type: 'info',
  message: 'For now you can only search on user and løpenr/prosjektnr',
  showBanner: true,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(AuxBanner), {
        type: banner.type
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(banner.message), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ], 512), [
      [_vShow, banner.showBanner]
    ])
  ]))
}
}

})